/**
 * @typedef {Object} Service
 * @property {string} id          Stable key, unique across all services.
 * @property {string} title       Name shown on the card, exactly as it should appear.
 * @property {string} description One-sentence summary shown under the title.
 * @property {string} image       Path relative to public/, e.g. images/services/grooming.png
 */

const IMAGE_DIR = 'images/services';

const image = (fileName) => `${IMAGE_DIR}/${fileName}`;

/**
 * Services grouped by theme, in display order:
 *   1. Veterinary care: in the clinic, at your home, and online.
 *   2. Everyday care: grooming and boarding.
 *   3. Shop and logistics: the pet store, delivery, and relocation.
 * @type {Service[]}
 */
export const SERVICES = [
  {
    id: 'veterinary-consultation',
    title: 'Veterinary Consultation',
    description: 'Comprehensive medical care by certified vets. Check-ups, vaccinations, surgery, and more.',
    image: image('vetServices.png'),
  },
  {
    id: 'mobile-vet-home-visits',
    title: 'Mobile Vet and Home Visits',
    description: 'Convenient veterinary care at your doorstep, ideal for busy owners or anxious pets.',
    image: image('mobile.png'),
  },
  {
    id: 'online-consultation-delivery',
    title: 'On-line Consultation & Delivery',
    description: 'Virtual vet advice and doorstep delivery of pet products and medicine.',
    image: image('delivery.png'),
  },
  {
    id: 'grooming',
    title: 'Grooming',
    description: 'Professional grooming for all breeds: bathing, trimming, nail care, and styling.',
    image: image('grooming.png'),
  },
  {
    id: 'pet-hotel-homestay',
    title: 'Pet Hotel & Homestay',
    description: 'Safe, comfortable short and long-term boarding with personalized care and playtime.',
    image: image('hotel.png'),
  },
  {
    id: 'pet-store',
    title: 'Pet Store',
    description: 'One-stop shop for quality pet food, accessories, toys, and essentials.',
    image: image('store.png'),
  },
  {
    id: 'pet-delivery-relocation',
    title: 'Pet Delivery Services & Relocation',
    description: 'Safe, stress-free transport for your pet, from local pick-up and drop-off to full relocation support.',
    image: image('pet-delivery.png'),
  },
];
